<template>
    <v-row v-if="order">
        <v-col cols="12">
            <status-info
                :order="order"
                @value-change="orderChange"
            ></status-info>
        </v-col>
        <v-col cols="12">
            <price-info
                :order="order"
                @value-change="orderChange"
            ></price-info>
        </v-col>
        <v-col>
            <payment-info
                :order="order"
                @value-change="orderChange"
            ></payment-info>
        </v-col>
        <v-col cols="12">
            <delivery-info
                :order="order"
                @value-change="orderChange"
            ></delivery-info>
        </v-col>
        <v-col cols="12">
            <buyer-info
                :order="order"
                @value-change="orderChange"
            ></buyer-info>
        </v-col>
        <v-col cols="12">
            <notes-info
                :order="order"
                @value-change="orderChange"
            ></notes-info>
        </v-col>
        <v-col cols="12" class="d-flex">
            <v-btn
                class="white--text"
                color="teal lighten-2"
                :disabled="deleted"
                @click="save"
            >{{ $t('save') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                text
                class="red--text"
                :disabled="deleted"
                @click="isOpenRemoveSnack = true"
            >{{ $t('remove') }}
            </v-btn>
        </v-col>

        <remove-snackbar
            v-model="isOpenRemoveSnack"
            :snack-color="editSnackColor"
            @close="resetRemoveSnack"
            @remove="remove"
        ></remove-snackbar>
    </v-row>
</template>

<script>
    import PriceInfo from './PriceInfo';
    import PaymentInfo from "./PaymentInfo";
    import StatusInfo from './StatusInfo';
    import DeliveryInfo from './DeliveryInfo';
    import NotesInfo from './NotesInfo';
    import { RemoveSnackbar } from '../../../components/snackbars';
    import { MixinEditSnack } from '../../../mixins';
    import BuyerInfo from './BuyerInfo';

    export default {
        name: 'OrderInfo',
        mixins: [MixinEditSnack],
        components: {
            BuyerInfo,
            NotesInfo,
            DeliveryInfo,
            PaymentInfo,
            PriceInfo,
            StatusInfo,
            RemoveSnackbar,
        },
        props: {
            order: {
                required: false,
                type: Object,
            },
            deleted: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                units: [],
                data: {},
                isOpenRemoveSnack: false,
            }
        },
        methods: {
            orderChange({ key, value }) {
                this.data[key] = value;
            },
            save() {
                if (!this.deleted) {
                    this.$emit('save', { ...this.data, id: this.order.id, product_id: this.order.product.id });
                }
            },
            remove() {
                if (!this.deleted) {
                    this.$emit('remove', this.order.id);
                }
            },
            resetRemoveSnack() {
                this.isOpenRemoveSnack = false;
                this.editSnackTimeout = 3000;
            },
        },
    }
</script>

<style scoped>

</style>
